import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/views/Header"),
  },
  {
    path: "/test",
    component: () => import("@/components/navBar"),
  },
  {
    path: "/404",
    component: () => import("@/views/Serviceing"),
  },
  {
    path: "/login",
    component: () => import("@/views/login"),
  },
  {
    path: "/register",
    component: () => import("@/views/register"),
  },
  {
    path: "/product",
    component: () => import("@/views/ProductDetail.vue"),
  },
  {
    path: "/productList",
    component: () => import("@/views/ProductList.vue"),
  },
  {
    path: "/categoryList",
    component: () => import("@/views/CategoryList.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
});

export default router;
